module.exports = __webpack_public_path__ + "img/keepGrain.6f2d78d0.png";